import React, { SVGProps } from 'react';
 
 const RegisterLocation: React.FC<SVGProps<SVGSVGElement>> = props => (
   <svg width="72" height="72" viewBox="0 0 72 72" fill="none" xmlns="http://www.w3.org/2000/svg">
     <g style={{mixBlendMode: 'soft-light'}}>
       <path fillRule="evenodd" clipRule="evenodd" d="M34.9826 62.6022C21.7045 50.3455 15 39.5152 15 30C15 18.402 24.402 9 36 9C47.598 9 57 18.402 57 30C57 39.5152 50.2955 50.3455 37.0174 62.6022C36.4428 63.1326 35.5572 63.1326 34.9826 62.6022ZM24 30C24 36.6274 29.3726 42 36 42C42.6274 42 48 36.6274 48 30C48 23.3726 42.6274 18 36 18C29.3726 18 24 23.3726 24 30ZM45 30C45 34.9706 40.9706 39 36 39C31.0294 39 27 34.9706 27 30C27 25.0294 31.0294 21 36 21C40.9706 21 45 25.0294 45 30ZM36 12C45.9411 12 54 20.0589 54 30C54 38.2555 48.0402 48.106 36 59.4491C23.9598 48.106 18 38.2555 18 30C18 20.0589 26.0589 12 36 12Z" fill="white"/>
     </g>
   </svg>
 
 );
 
 export default RegisterLocation;